var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { assertConfiguration } from "../AblyReactHooks";
export function usePresence(channelName, statusMessage) {
    const ably = assertConfiguration();
    const [presenceData, updatePresenceData] = useState([]);
    const channel = ably.channels.get(channelName);
    const updatePresence = () => __awaiter(this, void 0, void 0, function* () {
        updatePresenceData(yield channel.presence.get());
    });
    const updateStatus = (message) => {
        channel.presence.update(message);
    };
    const onMount = () => __awaiter(this, void 0, void 0, function* () {
        channel.presence.subscribe('enter', updatePresence);
        channel.presence.subscribe('leave', updatePresence);
        channel.presence.subscribe('update', updatePresence);
        yield channel.presence.enter(statusMessage || "");
        updatePresenceData(yield channel.presence.get());
    });
    const onUnmount = () => {
        channel.presence.leave();
        channel.presence.unsubscribe('enter');
        channel.presence.unsubscribe('leave');
        channel.presence.unsubscribe('update');
    };
    const useEffectHook = () => {
        onMount();
        return () => { onUnmount(); };
    };
    useEffect(useEffectHook, []);
    return [presenceData, updateStatus];
}
//# sourceMappingURL=usePresence.js.map